import React, { useState, useEffect } from "react";
import {
  Card,
  Typography,
  Radio,
  Select,
  Table,
  InputNumber,
  Space,
  Button,
  message,
  Tabs,
  Row,
  Col,
  Image,
} from "antd";
import {
  SaveOutlined,
  CalculatorOutlined,
} from "@ant-design/icons";
import axios from "axios";
import UniversalModuleModal from "./UniversalModuleModal";
import { MODULE_MODAL_CONFIGS } from "./moduleModalConfigs";

const { Title, Text } = Typography;
const { Option } = Select;
const { TabPane } = Tabs;

const GeneralServiceTimes = ({
  fileId,
  fileName,
  setSelectedFile,
  initialConfig,
  selectedFile,
}) => {

  const [activeTab, setActiveTab] = useState("1");
  const [loading, setLoading] = useState(false);
  const [resultData, setResultData] = useState(null);

  const [costOption, setCostOption] = useState("none");
  const [timeUnit, setTimeUnit] = useState("Hours");

  const [values, setValues] = useState({
    arrival_rate: 2,
    service_rate: 5,
    servers: 1,
    std_dev: 1,
  });

  const [name, setName] = useState(
    fileName || "General Service Times"
  );


  const handleLogout = () => {
    localStorage.removeItem("access_token");
    localStorage.removeItem("refresh_token");
    localStorage.removeItem("username");
    window.location.href = "/login";
  };


  useEffect(() => {

    if (selectedFile?.type === "general_service_times" && selectedFile.id) {

      fetchAnalysis(selectedFile.id);

    }
    else if (fileId) {

      fetchAnalysis(fileId);

    }
    else if (initialConfig) {

      setName(
        initialConfig.name || "General Service Times"
      );

    }

  }, [selectedFile, fileId]);



  const fetchAnalysis = async (id = fileId) => {

    setLoading(true);

    try {

      const token = localStorage.getItem("access_token");

      const response = await axios.get(
        `/api/retrieve_general_service_times/${id}/`,
        {
          headers: {
            Authorization: `Bearer ${token}`
          }
        }
      );


      const {
        name,
        input_data,
        output_data,
        chart_url
      } = response.data;


      setName(name);

      setValues({
        arrival_rate: input_data.arrival_rate || 0,
        service_rate: input_data.service_rate || 0,
        servers: input_data.servers || 1,
        std_dev: input_data.std_dev || 1,
      });


      setCostOption(
        input_data.costOption || "none"
      );

      setTimeUnit(
        input_data.timeUnit || "Hours"
      );


      setResultData({
        output_data,
        chart_url
      });


    } catch (error) {

      console.log("FULL ERROR:", error);

      if (error.response) {

        console.log("STATUS:", error.response.status);
        console.log("DATA:", error.response.data);

        message.error(
          error.response.data.error ||
          error.response.data.detail ||
          "Calculation failed"
        );

      }
      else {

        message.error("Server not reachable");

      }

    }
    finally {
      setLoading(false);
    }

  };



  const updateValue = (field, value) => {

    setValues(prev => ({
      ...prev,
      [field]: value
    }));

  };

  const handleSolve = async () => {

    console.log("GENERAL SERVICE CALCULATE CLICKED");
    console.log("VALUES:", values);

    const token = localStorage.getItem("access_token");
    console.log("TOKEN:", token);

    setLoading(true);

    try {

      const payload = {
        name: name,
        input_data: {
          ...values,
          costOption,
          timeUnit
        }
      };

      console.log("PAYLOAD:", payload);

      let response;


      if (fileId) {

        response = await axios.put(
          `/api/update_general_service_times/${fileId}/`,
          payload,
          {
            headers: {
              Authorization: `Bearer ${token}`
            }
          }
        );

      }
      else {

        response = await axios.post(
          "/api/save_general_service_times/",
          payload,
          {
            headers: {
              Authorization: `Bearer ${token}`
            }
          }
        );


        setSelectedFile({
          id: response.data.id,
          name: response.data.name,
          type: "general_service_times"
        });

      }


      console.log("SUCCESS RESPONSE:", response.data);


      setResultData({
        output_data: response.data.output_data,
        chart_url: response.data.chart_url
      });


      message.success("Saved and calculated successfully");

      setActiveTab("2");


    }
    catch (error) {

      console.log("FULL ERROR:", error);


      if (error.response) {

        console.log("STATUS:", error.response.status);
        console.log("DATA:", error.response.data);


        message.error(
          error.response.data.detail ||
          error.response.data.error ||
          "Calculation failed"
        );

      }
      else {

        message.error("Server not reachable");

      }

    }
    finally {

      setLoading(false);

    }

  };

  const renderResults = () => {

    if (
      !resultData ||
      !resultData.output_data
    )
      return null;


    const tableData = Object.entries(
      resultData.output_data
    ).map(([key, value], index) => ({

      key: index,

      parameter: key
        .replaceAll("_", " ")
        .toUpperCase(),

      value: value

    }));


    const columns = [

      {
        title: "Parameter",
        dataIndex: "parameter",
        key: "parameter"
      },

      {
        title: "Value",
        dataIndex: "value",
        key: "value"
      }

    ];


    return (

      <Card title="Results">

        <Table

          columns={columns}

          dataSource={tableData}

          pagination={false}

          bordered

        />

      </Card>

    );

  };



  return (

    <Card

      title={
        <Title level={4}>
          {name}
        </Title>
      }


      extra={

        <Button

          type="primary"

          icon={<SaveOutlined />}

          onClick={handleSolve}

          loading={loading}

        >

          {
            fileId
              ?
              "Update & Solve"
              :
              "Save & Solve"
          }

        </Button>

      }


    >


      <Tabs
        activeKey={activeTab}
        onChange={setActiveTab}
      >


        <TabPane
          tab="Inputs"
          key="1"
        >


          <Row gutter={[24, 24]}>

            <Col span={12}>


              <Card title="Parameters">


                <div>

                  <Text strong>
                    Arrival Rate (λ)
                  </Text>


                  <InputNumber

                    style={{
                      width: "100%",
                      marginTop: 8
                    }}

                    value={values.arrival_rate}

                    onChange={
                      v => updateValue(
                        "arrival_rate",
                        v
                      )
                    }

                  />

                </div>



                <div style={{ marginTop: 15 }}>

                  <Text strong>
                    Service Rate (μ)
                  </Text>


                  <InputNumber

                    style={{
                      width: "100%",
                      marginTop: 8
                    }}

                    value={values.service_rate}

                    onChange={v => updateValue("service_rate", v)}

                  />

                </div>



                <div style={{ marginTop: 15 }}>

                  <Text strong>
                    Number of Servers
                  </Text>


                  <InputNumber

                    min={1}

                    style={{
                      width: "100%",
                      marginTop: 8
                    }}

                    value={values.servers}

                    onChange={
                      v => updateValue(
                        "servers",
                        v
                      )
                    }

                  />

                </div>
                <div style={{ marginTop: 15 }}>
                  <Text strong>
                    Standard Deviation
                  </Text>

                  <InputNumber
                    style={{
                      width: "100%",
                      marginTop: 8,
                    }}
                    value={values.std_dev}
                    onChange={(v) => updateValue("std_dev", v)}
                  />
                </div>


              </Card>

            </Col>





            <Col span={12}>


              <Card title="Options">


                <Text strong>
                  Cost Analysis
                </Text>


                <br />


                <Radio.Group

                  value={costOption}

                  onChange={
                    e => setCostOption(
                      e.target.value
                    )
                  }

                >

                  <Space direction="vertical">

                    <Radio value="none">
                      No Costs
                    </Radio>


                    <Radio value="use">
                      Use Costs
                    </Radio>


                  </Space>


                </Radio.Group>



                <br /><br />


                <Text strong>
                  Time Unit
                </Text>


                <Select

                  style={{
                    width: "100%",
                    marginTop: 8
                  }}

                  value={timeUnit}

                  onChange={setTimeUnit}

                >

                  <Option value="Seconds">
                    Seconds
                  </Option>

                  <Option value="Minutes">
                    Minutes
                  </Option>

                  <Option value="Hours">
                    Hours
                  </Option>

                  <Option value="Days">
                    Days
                  </Option>


                </Select>



                {
                  costOption === "use" &&

                  <>

                    <br /><br />


                    <Text strong>
                      Server Cost
                    </Text>


                    <InputNumber

                      style={{
                        width: "100%"
                      }}

                      value={values.serverCost}

                      onChange={
                        v => updateValue(
                          "serverCost",
                          v
                        )
                      }

                    />



                    <br /><br />


                    <Text strong>
                      Waiting Cost
                    </Text>


                    <InputNumber

                      style={{
                        width: "100%"
                      }}

                      value={values.waitingCost}

                      onChange={
                        v => updateValue(
                          "waitingCost",
                          v
                        )
                      }

                    />


                  </>

                }



              </Card>


            </Col>


          </Row>




          <div
            style={{
              marginTop: 20,
              textAlign: "center"
            }}
          >


            <Button

              type="primary"

              size="large"

              icon={<CalculatorOutlined />}

              onClick={handleSolve}

              loading={loading}

            >

              Calculate

            </Button>


          </div>


        </TabPane>





        <TabPane

          tab="Results"

          key="2"

          disabled={!resultData}

        >


          {renderResults()}



          {
            resultData?.chart_url &&

            <Card title="Chart">

              <Image

                src={
                  resultData.chart_url.startsWith("http")
                    ?
                    resultData.chart_url
                    :
                    `http://127.0.0.1:8000${resultData.chart_url}`
                }

              />

            </Card>

          }



        </TabPane>


      </Tabs>


    </Card>

  );


};


export default GeneralServiceTimes;